import { Col, Row } from 'antd';
import styles from './InputWithComma.module.scss';

export default function InputWithComma({ value, name, error, unit }: { value: string, name: string, error?: string, unit?: string }) {
  return (
    <div style={{ width: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
      <Row gutter={[20, 0]} style={{ justifyContent: 'center' }}>
        <Col span={4}>
          <div className={styles.InputWithComma}>
            {value?.slice(0, 1)}
          </div>
        </Col>
        <Col span={4}>
          <div className={styles.InputWithComma}>
            {value?.slice(1, 2)}
          </div>
        </Col>
        <div className={styles.Comma} style={{ position: 'relative', top: '25px' }}>
          ,
        </div>
        <Col span={4}>
          <div className={styles.InputWithComma}>
            {value?.slice(2, 3)}
          </div>
        </Col>
        <Col span={2}>
          <div className={styles.Comma} style={{ marginLeft: '90px' }}>{unit}</div>
        </Col>
        <input type="number" name={name} hidden maxLength={3} value={value} />
      </Row>
    </div>
  )

}